(function () {
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  var PING_HEADER = 'x-ctc-atc-ping';
  function isAddUrl(u) { return typeof u === 'string' && ADD_RE.test(u); }
  function firstVariantId(json) {
    try {
      var obj = typeof json === 'string' ? JSON.parse(json) : json;
      if (!obj) return null;
      if (obj.items && obj.items.length) return obj.items[0].id || obj.items[0].variant_id;
      return obj.id || obj.variant_id || null;
    } catch (e) { return null; }
  }
  var lastPing = 0;
  function trackAdd(json) {
    try {
      var id = firstVariantId(json);
      if (!id) return;
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      if (now - lastPing < 400) return;
      lastPing = now;
      var headers = { 'Content-Type': 'application/json' };
      headers[PING_HEADER] = '1';
      window.fetch('/cart/add.js', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ id: id, quantity: 0 })
      }).catch(function () {});
    } catch (e) {}
  }
  try {
    var XO = XMLHttpRequest.prototype.open;
    var XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__ctcAddUrl = url; } catch (e) {}
      return XO.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (isAddUrl(this.__ctcAddUrl)) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300) {
              trackAdd(this.responseText);
            }
          });
        }
      } catch (e) {}
      return XS.apply(this, arguments);
    };
  } catch (e) {}
})();

/* CTC slide-cart empty-state fix (v3 — targets the real #dropdown-cart drawer)
 *
 * Problem: When the last item is removed from the cart drawer, this theme
 * updates the item count to 0 but leaves a phantom line item in the drawer
 * and does not reliably reveal the empty state until the page is refreshed.
 *
 * The drawer markup is #dropdown-cart with sibling blocks .no-items (empty
 * message) and .has-items (line items + totals + checkout). The theme toggles
 * those with a JS-driven display swap that is racey on remove-to-zero, and it
 * fails to clear the <li> from .mini-products-list.
 *
 * Fix: after any cart mutation, re-read /cart.js. When item_count is 0, add a
 * .ctc-empty class to #dropdown-cart (an injected !important stylesheet forces
 * .no-items visible and .has-items hidden, beating the theme's own toggle) and
 * strip any leftover <li>. When item_count is > 0, remove the class so the
 * theme renders normally and a real cart is never hidden. A short
 * MutationObserver keeps the empty state applied for ~2.5s to win the race
 * against the theme's async re-render. Fully defensive and only ever forces the
 * empty state when the server confirms the cart is empty.
 */
(function () {
  var STYLE_ID = 'ctc-empty-style';
  var MUT_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var observer = null, guardUntil = 0;

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '#dropdown-cart.ctc-empty .has-items{display:none!important}' +
      '#dropdown-cart.ctc-empty .no-items{display:flex!important}' +
      '#dropdown-cart.ctc-empty .wrapper-cartCount{display:none!important}';
    (document.head || document.documentElement).appendChild(s);
  }

  function apply(empty) {
    var dc = document.querySelector('#dropdown-cart');
    if (!dc) return;
    if (empty) {
      dc.classList.add('ctc-empty');
      dc.querySelectorAll('.mini-products-list > li').forEach(function (li) { li.remove(); });
    } else {
      dc.classList.remove('ctc-empty');
    }
  }

  function sync() {
    injectStyle();
    window.fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        try {
          document.querySelectorAll('[data-cart-count],.cartCount').forEach(function (n) {
            n.textContent = cart.item_count;
          });
          var empty = cart.item_count === 0;
          apply(empty);
          if (!empty) return;
          guardUntil = Date.now() + 2500;
          var dc = document.querySelector('#dropdown-cart');
          if (!dc) return;
          if (!observer) {
            observer = new MutationObserver(function () {
              if (Date.now() > guardUntil) { observer.disconnect(); observer = null; return; }
              apply(true);
            });
            observer.observe(dc, { childList: true, subtree: true });
            setTimeout(function () { if (observer) { observer.disconnect(); observer = null; } }, 2700);
          }
        } catch (e) {}
      })
      .catch(function () {});
  }

  // Catch jQuery XHR cart mutations (adds/changes/updates/clears).
  try {
    var XO2 = XMLHttpRequest.prototype.open;
    var XS2 = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__ctcMut = (typeof url === 'string' && MUT_RE.test(url)); } catch (e) {}
      return XO2.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (this.__ctcMut) {
          this.addEventListener('load', function () {
            setTimeout(sync, 250);
            setTimeout(sync, 900);
          });
        }
      } catch (e) {}
      return XS2.apply(this, arguments);
    };
  } catch (e) {}

  // Fallback: clicks on a remove control or anywhere inside the drawer
  // (the drawer's remove/qty controls use fetch, not XHR).
  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      var inDrawer = t && t.closest ? t.closest('#dropdown-cart') : null;
      var isRemove = t && t.closest ? t.closest('.btn-remove,.cart-remove') : null;
      if (inDrawer || isRemove) { setTimeout(sync, 350); setTimeout(sync, 1200); }
    } catch (err) {}
  }, true);

  // Safety: when the cart drawer is opened, reconcile so a stale empty state is
  // cleared before the shopper sees it.
  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (t && t.closest && t.closest('[data-cart-toggle],.cart-icon,.cart-link,.cart-text')) {
        setTimeout(sync, 300);
      }
    } catch (err) {}
  }, true);
})();
